import React from 'react';
import _ from "underscore";

import Container from "react-bootstrap/Container";

import config from "../../config";
import Nav from "react-bootstrap/Nav";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

const MagazineMenu = ({ articles, vault_articles }) => {
    if(_.isEmpty(articles && vault_articles)){
        return null;
    }

    const vault_articles_list = vault_articles.items;

    return (
        <div className="top-nav">
            <Container>
                <Row>
                    <Col xl={{ span: 2, offset: 1 }} lg={{ span: 2, offset: 0 }}>
                        <h4 className="top-nav__nav-title">The Vault</h4>
                        <Nav className="top-nav__nav-list">
                            {_.map(vault_articles_list.slice(2, 7), (article, idx) => {
                                return (
                                    <Nav.Item
                                        key={idx}
                                        className="top-nav__nav-list-item-secondary nav-link nav-top-link"
                                        as="a"
                                        href={article.url}
                                    >
                                        {article.title}
                                    </Nav.Item>
                                )
                            })}
                            <Nav.Item
                                className="top-nav__nav-list-item-secondary nav-link nav-top-link"
                                as="a"
                                href={config.host_rebag_vault}
                            >
                                All Articles
                            </Nav.Item>
                        </Nav>
                    </Col>
                    <Col xl={4} lg={5}>
                        <MagazineArticle key="article-last" article={vault_articles_list[0]} />
                    </Col>
                    <Col xl={4} lg={5}>
                        <MagazineArticle key="article-before-last" article={vault_articles_list[1]} />
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

const MagazineArticle = ({ article }) => {
    return (
        <div className="top-nav__article">
            <a href={article.url}>
                <div className="top-nav__article-img">
                    <img
                        alt={article.title}
                        src={article.header_vault_image || article.image}
                        title={article.title}
                    />
                </div>
                <div className="top-nav__article-text">
                    <h2 className="top-nav__article-title top-nav__article-title--caps">
                        {article.title}
                    </h2>
                    <div className="top-nav__article-excerpt">
                        Read More
                    </div>
                </div>
            </a>
        </div>
    )
}

export default MagazineMenu;